import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import VideoTemplate from './VideoTemplate'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import { lang } from '../../assets/lang'

export default class VideoComponent extends Rete.Component {
  constructor (config) {
    super(CONST_COMPONENT.VIDEO)

    this.data.component = VideoTemplate
    this.socket = config ? config.sockets : null
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
  }

  builder (node) {
    node.lingualName = lingualName.VIDEO
    this.setConnection()

    const videoInput = new Rete.Input(CONST_SOCKET.VIDEO_INPUT, lang.video_socket_input_reply, this.socket.videoInput, true)
    const videoOutput = new Rete.Output(CONST_SOCKET.VIDEO_OUTPUT, lang.video_socket_output_next, this.socket.videoOutput, false)
    const videoOutputQuickreply = new Rete.Output(CONST_SOCKET.VIDEO_OUTPUT_QUICKREPLY, lang.video_socket_output_quick_replies, this.socket.videoOutputQuickreply, true)

    return node
      .addInput(videoInput)
      .addOutput(videoOutput)
      .addOutput(videoOutputQuickreply)
  }

  // eslint-disable-next-line
  worker (node, inputs, outputs) {
    outputs[CONST_SOCKET.VIDEO_OUTPUT] = node.data
  }

  setConnection() {
    // Video may take connections from:
    this.socket.videoInput.combineWith(this.socket.referenceOutput)
    this.socket.videoInput.combineWith(this.socket.newPostbackOutput)
    this.socket.videoInput.combineWith(this.socket.textOutput)
    this.socket.videoInput.combineWith(this.socket.carouselOutput)
    this.socket.videoInput.combineWith(this.socket.facebookMediaOutput)
    this.socket.videoInput.combineWith(this.socket.imageOutput)
    this.socket.videoInput.combineWith(this.socket.videoOutput)
    this.socket.videoInput.combineWith(this.socket.audioOutput)
    this.socket.videoInput.combineWith(this.socket.fileOutput)
    this.socket.videoInput.combineWith(this.socket.ecommerceOutput)
    this.socket.videoInput.combineWith(this.socket.genericTemplateOutput)
    this.socket.videoInput.combineWith(this.socket.otnOutput)

    // Video may be connected to:
    this.socket.videoOutput.combineWith(this.socket.textInput)
    this.socket.videoOutput.combineWith(this.socket.carouselInput)
    this.socket.videoOutput.combineWith(this.socket.facebookMediaInput)
    this.socket.videoOutput.combineWith(this.socket.imageInput)
    this.socket.videoOutput.combineWith(this.socket.videoInput)
    this.socket.videoOutput.combineWith(this.socket.audioInput)
    this.socket.videoOutput.combineWith(this.socket.fileInput)
    this.socket.videoOutput.combineWith(this.socket.ecommerceInput)
    this.socket.videoOutput.combineWith(this.socket.genericTemplateInput)
    this.socket.videoOutput.combineWith(this.socket.otnInput)
    this.socket.videoOutput.combineWith(this.socket.componentListInput)

    if (this.isUserInputFlowAddonAvailable) {
      this.socket.videoOutput.combineWith(this.socket.userInputFlowInput)
    }

    // Output (QuickReply): QuickReply
    this.socket.videoOutputQuickreply.combineWith(this.socket.quickReplyInput)    
  }
}